import React from 'react';
import Link from '../next-ui/Link';
import Button from '../next-ui/Button';
import Typography from '../next-ui/Typography';
import { Menu, Transition } from '@headlessui/react';
import { HiOutlineMenu } from 'react-icons/hi';
import { DOMAIN_PREFIX_REDIRECTS } from '@/constants/orgConfig.constant';
import { useBreakpointHooks } from '@/utils/break-points.provider';

const menuItems = [
  { label: 'NEKI for Organizations', href: 'https://neki.io' },
  { label: 'NEKI for Non-Profits', href: 'https://neki.io' },
  { label: 'Global Partners', href: 'https://neki.io' },
  { label: 'Discover Non-Profits', href: '/explore', internal: true },
];

function GuestAppBarMenu() {
  const isGreaterThanMediumScreen = useBreakpointHooks((bp) =>
    bp.useGreater('md'),
  );

  const clearCookie = (name) => {
    const path = '/'; // Adjust if needed
    const domain = ''; // Adjust if needed
    const secure = false; // Set to true if your site uses HTTPS

    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; ${
      secure ? 'secure; ' : ''
    }SameSite=Lax;`;
  };

  const handleLogout = () => {
    const loginUrl = DOMAIN_PREFIX_REDIRECTS[window.location.hostname];
    if (loginUrl) {
      window.location.href = loginUrl;
      return;
    }
    clearCookie('appSession');
    window.location.href = '/api/auth/logout';
  };

  return (
    <div className="flex items-center gap-4 md:flex-row-reverse">
      {/* <Link href="/api/auth/login" prefetch={false}>
        <Button className="px-3 py-0.5 sm:px-2 sm:py-1">Login</Button>
      </Link> */}

      {isGreaterThanMediumScreen && (
        <Button className="px-3 py-0.5 sm:px-2 sm:py-1" onClick={handleLogout}>
          Login
        </Button>
      )}

      <div className="flex md:hidden">
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
            <HiOutlineMenu aria-hidden="true" />
          </Menu.Button>
          <Transition
            as={React.Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95">
            <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="px-3 py-1 ">
                {menuItems.map((item) => (
                  <Menu.Item key={item.label}>
                    {() => (
                      <Link href={item.href} prefetch={false}>
                        <Typography
                          variant="body2"
                          className="py-2 hover:text-secondary">
                          {item.label}
                        </Typography>
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      <div className="hidden items-center gap-4 md:flex">
        {menuItems.map((item) => (
          <Link key={item.label} href={item.href} prefetch={false}>
            <Typography variant="body2" className="hover:text-secondary">
              {item.label}
            </Typography>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default GuestAppBarMenu;
